import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { clone } from 'lodash';
import moment from 'moment-timezone';
import { object, func, string, array } from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import getFormattedError from '../../api-wrapper/get-formatted-error';
import useApi from '../../api-wrapper/use-api.js';
import {
   URL_CORE_PRICING_SEARCH,
   URL_DYNAMIC_RESOLUTION,
   URL_CORE_PRICING_NEW_FARES_SAVE,
   URL_NEW_DISTRIBUTION_GROUP_SEARCH,
} from '../../end-points.js';
import NewDistributionGroup from '../../ui-components/core-pricing-component/new-distribution-group/new-distribution-group.jsx';
import SearchCriteria from '../../ui-components/core-pricing-component/search-cirteria/search-criteria.jsx';
import TableView from '../../ui-components/core-pricing-component/table-view/table-view.jsx';
import LayoutTwoVerticalGrids from '../../ui-components/layouts/layout-two-vertical-grids.jsx';
import Loader from '../../ui-components/loader/loader.jsx';
import {
   calculateHeader,
   calculateJoinData,
   calculateParsingData,
   calculateSeprationTableCaption,
   generationgTableObjects,
   calculateResultDetails,
} from '../../utils/common-util.js';
import {
   TOOL_BAR_BUTTONS,
   SIZE,
   MATH_OPERATIONS,
   ROW_COPY_ENABLED_FARES_SCREEN_COLUMN,
   CAMEL_CASE_ACTION,
   CAMEL_CASE_TYPES,
   SCREEN_NAMES,
   USER_ACTION_CODE_FARES_SCREEN,
   FARE_STATUS,
} from '../../utils/constants.js';
import { DateUtil } from '../../utils/date-util.js';
import { getApiHeaders } from '../../utils/header-util.js';
import { NOTIFICATION_MESSAGES } from '../../utils/notification-messages.js';
import { toastSuccess, toastWarn } from '../../utils/toasts.js';

const CorePricingFares = ({
   app,
   getTableData,
   selectedScreen,
   getSearchCriteriaParent,
   loadTime,
   getFullDataIsAvailable,
   handleDistributionScreenNavigation,
   handleNewFaresErrorPopupOpen,
   handleDeleteDistributionMenuClick,
   deleteConformedDistributionList,
}) => {
   const todayDate = new Date();
   const [cancelToken, setCancelToken] = useState(null);
   const [stopApiRequest, setStopApiRequest] = useState(false);
   const [fetchConfig, setFetchConfig] = useState({
      data: [],
      isLoading: false,
      error: '',
      requestedData: [],
      pageToken: null,
      jobId: null,
      table: '',
      type: CAMEL_CASE_ACTION.SEARCH_ACTION,
      isStopAPI: false,
      totalItem: 0,
   });
   const [corePricingConfig, setCorePricingConfig] = useState({
      isShowStoredCriteriaPopupModal: false,
      sepratorCaption: 0,
      storedCriteriaData: [],
      primaryTable: [],
      secondaryTable: [],
      primaryHeaderDetails: [],
      secondaryHeaderDetails: [],
      joinTableData: [],
      joinTableHeaders: [],
      isOpenStoredCriteria: false,
      uniqueFilters: [],
      isLeftSideLayoutOpen: true,
      selectedTab: TOOL_BAR_BUTTONS[0].KEY,
      titleDetails: [],
      isSaveSearchCriteria: false,
      selectedRowDetails: {},
      selectedCellIndex: 0,
      isFilterApply: false,
      pageToken: null,
      insertIndex: null,
      distributionNumber: '',
      isDistributionNumberApiCall: false,
      isSave: false,
   });
   const [abort, setAbort] = useState({
      isAbort: false,
      searchCriteriaDetails: [],
   });
   let isEmptyValue = false;
   const primaryTableReference = useRef();
   const secondaryTableReference = useRef();
   const [searchCriteriaConfig, setSearchCriteriaConfig] = useState([]);
   const [isTariffNumberAvailable, setIsTariffNumberAvailable] =
      useState(false);
   const [searchUrl, setSearchUrl] = useState('');
   const [newTemplateId, setNewTemplateId] = useState([]);
   const [saveNewFares, setSaveNewFares] = useApi({});
   const [distributionFetchApi, setDistributionFetchApi] = useApi({});
   const [faresDeleteApi, setFaresDeleteApi] = useApi({});

   useEffect(() => {
      if (app.foSimpleHep.FO_NGDS_DYNAMIC_RESOLUTION) {
         setSearchUrl(URL_DYNAMIC_RESOLUTION);
      } else {
         setSearchUrl(URL_CORE_PRICING_SEARCH);
      }
   }, []);

   useEffect(() => {
      getSearchCriteriaParent(searchCriteriaConfig);
   }, [searchCriteriaConfig]);
   useEffect(() => {
      if (sessionStorage.getItem('distributionNumbers') && loadTime) {
         const faresApiSowFaresRequestPayload = {
            distributions: [
               {
                  key: 'dgNumber',
                  operator: '=',
                  value: sessionStorage.getItem('distributionNumbers'),
               },
            ],
            hostCarrier: sessionStorage.getItem('carrierCode'),
         };
         setFetchConfig({
            ...fetchConfig,
            data: [],
            isLoading: true,
            error: '',
            requestedData: faresApiSowFaresRequestPayload,
            type: CAMEL_CASE_ACTION.SEARCH_ACTION,
            isStopAPI: false,
         });
         callFetchFaresService();
         sessionStorage.removeItem('distributionNumbers');
      }
   }, [loadTime]);

   const updateRowConfig = (newFaresDetails, data, type) => {
      if (data.length > 0)
         data.map((list) => {
            newFaresDetails.push(
               corePricingConfig.primaryTable.findIndex(
                  (subList, index) =>
                     subList.fareKey === list.fareKey &&
                     !newFaresDetails.includes(index)
               )
            );
         });
      const primary = clone(corePricingConfig.primaryTable);
      const secondary = clone(corePricingConfig.secondaryTable);
      const join = clone(corePricingConfig.joinTableData);
      newFaresDetails =
         newFaresDetails?.length > 0 &&
         newFaresDetails?.filter((index) => index >= 0);
      if (newFaresDetails) {
         newFaresDetails.map((listIndex) => {
            primary[listIndex].isSave =
               type === CAMEL_CASE_TYPES.SUCCESS ? true : false;
            primary[listIndex].isReject =
               type === CAMEL_CASE_TYPES.REJECT ? true : false;
            primary[listIndex].uac =
               type === CAMEL_CASE_TYPES.REJECT
                  ? USER_ACTION_CODE_FARES_SCREEN.ERROR
                  : corePricingConfig.primaryTable[listIndex].uac;
            primary[listIndex].isInsert = false;
            primary[listIndex].dg = data.length > 0 ? data[0].dgNumber : '';
            secondary[listIndex].isSave =
               type === CAMEL_CASE_TYPES.SUCCESS ? true : false;
            secondary[listIndex].isReject =
               type === CAMEL_CASE_TYPES.REJECT ? true : false;
            secondary[listIndex].uac =
               type === CAMEL_CASE_TYPES.REJECT
                  ? USER_ACTION_CODE_FARES_SCREEN.ERROR
                  : corePricingConfig.secondaryTable[listIndex].uac;
            secondary[listIndex].isInsert = false;
            secondary[listIndex].dg = data.length > 0 ? data[0].dgNumber : '';
            join[listIndex].isSave =
               type === CAMEL_CASE_TYPES.SUCCESS ? true : false;
            join[listIndex].isReject =
               type === CAMEL_CASE_TYPES.REJECT ? true : false;
            join[listIndex].uac =
               type === CAMEL_CASE_TYPES.REJECT
                  ? USER_ACTION_CODE_FARES_SCREEN.ERROR
                  : corePricingConfig.joinTableData[listIndex].uac;
            join[listIndex].isInsert = false;
            join[listIndex].dg = data.length > 0 ? data[0].dgNumber : '';
            if (type === CAMEL_CASE_TYPES.SUCCESS) {
               primary[listIndex].status = FARE_STATUS.WORKING;
               secondary[listIndex].status = FARE_STATUS.WORKING;
               join[listIndex].status = FARE_STATUS.WORKING;
            }
         });
      }
      setCorePricingConfig({
         ...corePricingConfig,
         primaryTable: primary,
         secondaryTable: secondary,
         joinTableData: join,
      });
      return newFaresDetails;
   };

   const validateFaresApprovaStaus = (data) => {
      var newFaresDetails = [];
      const failedData = data.filter(
         (list) => list.userActionCode === USER_ACTION_CODE_FARES_SCREEN.ERROR
      );
      const successData = data.filter(
         (list) => list.userActionCode !== USER_ACTION_CODE_FARES_SCREEN.ERROR
      );
      if (successData.length > 0) {
         toastSuccess(
            `${successData.length} working fares created successfully in ${successData[0].dgNumber} distribution group`
         );
         newFaresDetails.concat(
            updateRowConfig([], successData, CAMEL_CASE_TYPES.SUCCESS)
               .newFaresDetails
         );
      }
      if (failedData.length > 0) {
         if (failedData.length <= 3) {
            failedData.map((item) => {
               toastWarn(`${item.reason}-${item.fareKey}`);
            });
            newFaresDetails.concat(
               updateRowConfig([], failedData, CAMEL_CASE_TYPES.REJECT)
                  .newFaresDetails
            );
         } else {
            const fullError = failedData.map(({ fareKey, ...item }) => item);
            newFaresDetails.concat(
               updateRowConfig([], failedData, CAMEL_CASE_TYPES.REJECT)
                  .newFaresDetails
            );
            handleNewFaresErrorPopupOpen(fullError);
         }
      }
   };

   useEffect(() => {
      if (
         !saveNewFares.error &&
         !saveNewFares.isLoading &&
         saveNewFares.data.length > 0
      ) {
         validateFaresApprovaStaus(saveNewFares.data);
      } else if (saveNewFares.error) {
         toastWarn(saveNewFares.error);
      }
   }, [saveNewFares.isLoading]);
   const removeDeletedFaresList = () => {
      const indexDetails = clone([
         ...new Set(corePricingConfig.selectedRowDetails.selectedRowIndex),
      ]);
      const selectedDetails = indexDetails.map(
         (itemIndex) => corePricingConfig.primaryTable[itemIndex]
      );
      const resultId = selectedDetails.filter((list) => {
         return list.id;
      });
      const newPrimaryTable = clone(corePricingConfig.primaryTable);
      const newSecondaryTable = clone(corePricingConfig.secondaryTable);
      const newJoinTable = clone(corePricingConfig.joinTableData);
      selectedDetails.map((item) => {
         const primary = newPrimaryTable
            .map((list) => list.id)
            .indexOf(item.id);
         const secondary = newSecondaryTable
            .map((list) => list.id)
            .indexOf(item.id);
         const join = newJoinTable.map((list) => list.id).indexOf(item.id);
         newPrimaryTable.splice(primary, 1);
         newSecondaryTable.splice(secondary, 1);
         newJoinTable.splice(join, 1);
      });
      setCorePricingConfig({
         ...corePricingConfig,
         primaryTable: newPrimaryTable,
         secondaryTable: newSecondaryTable,
         joinTableData: newJoinTable,
         selectedRowDetails: {
            currentRow: corePricingConfig.selectedRowDetails.currentRow,
            selectedCellIndex:
               corePricingConfig.selectedRowDetails.selectedCellIndex,
            selectedCellTableType:
               corePricingConfig.selectedRowDetails.selectedCellTableType,
            selectedRowIndex: [corePricingConfig.selectedRowDetails.currentRow],
         },
      });
   };
   useEffect(() => {
      if (
         deleteConformedDistributionList &&
         corePricingConfig.primaryTable.length > 0
      ) {
         toastSuccess(NOTIFICATION_MESSAGES.DISTRIBUTION_DELETE_SUCCESS);
         removeDeletedFaresList();
      }
   }, [deleteConformedDistributionList]);

   const getSearchCriteria = (searchCriteria, type, title) => {
      setSearchCriteriaConfig(searchCriteria);
      if (type === 'clear') {
         setFetchConfig({
            ...fetchConfig,
            isLoading: false,
            error: '',
            requestedData: {
               hostCarrier: fetchConfig.requestedData.hostCarrier,
            },
            pageToken: undefined,
            table: '',
            type: CAMEL_CASE_ACTION.SEARCH_ACTION,
            isStopAPI: !fetchConfig.isStopAPI ? false : true,
         });
         setIsTariffNumberAvailable(false);
         setStopApiRequest(false);
      }
      if (title) setSavedSearchCriteriaTitle(title);
   };
   const callFetchFaresService = async () => {
      if (Object.keys(fetchConfig.requestedData).length === 0) return;
      const headers = {};
      const requestObject = Object.assign(fetchConfig);
      if (requestObject.type === CAMEL_CASE_ACTION.SEARCH_ACTION) {
         if (cancelToken) {
            cancelToken.cancel('Query canceled.');
         }
         requestObject.requestedData.pageToken = null;
         requestObject.requestedData.bqJobInfo = null;
      } else if (requestObject.totalItem) {
         requestObject.requestedData.pageToken = requestObject.pageToken;
         requestObject.requestedData.bqJobInfo = requestObject.jobId;
      }
      delete requestObject.requestedData.jobId;
      requestObject.requestedData.latestLoadTransmission = loadTime;
      const source = axios.CancelToken.source();
      setCancelToken(source);
      try {
         const fetchResultData = await axios({
            url: searchUrl,
            method: 'POST',
            cancelToken: source.token,
            headers: getApiHeaders(headers),
            data: requestObject.requestedData,
         }).catch((err) => {
            setFetchConfig({
               ...fetchConfig,
               error: err.message,
               data: [],
               isLoading: false,
            });
         });
         if (fetchResultData) {
            if (
               corePricingConfig.joinTableData.length !==
                  parseInt(
                     fetchResultData &&
                        fetchResultData.data &&
                        fetchResultData.data.totalNumberOfFaresFound
                  ) ||
               parseInt(fetchResultData.data.totalNumberOfFaresFound) === 0
            )
               setFetchConfig({
                  ...fetchConfig,
                  data: fetchResultData.data.resolvedFares,
                  totalItem:
                     requestObject.type === CAMEL_CASE_ACTION.SEARCH_ACTION
                        ? fetchResultData.data.totalNumberOfFaresFound
                        : fetchConfig.totalItem,
                  jobId: !fetchConfig.jobId
                     ? fetchResultData.data.jobId
                     : fetchConfig.jobId,
                  pageToken: fetchResultData.data.pageToken,
                  isLoading: false,
                  error: '',
                  isStopAPI: false,
               });
         }
      } catch (error) {
         setFetchConfig({
            ...fetchConfig,
            data: [],
            isLoading: false,
            error: getFormattedError(error).content,
         });
         setAbort({
            isAbort: false,
         });
      }
   };
   useEffect(() => {
      if (fetchConfig.error) {
         toastWarn(fetchConfig.error);
      }
      getTableData({
         joinTable: corePricingConfig.joinTableData,
         primaryTableLength: corePricingConfig.primaryTable.length,
         totalItem: fetchConfig.totalItem,
         isCompleted: true,
      });
   }, [fetchConfig.error]);

   useEffect(() => {
      if (abort.isAbort) {
         searchCriteriaParsing(abort.searchCriteriaDetails);
         setAbort({
            ...abort,
            isAbort: false,
         });
         return;
      }
      if (corePricingConfig.pageToken) {
         navigationPagination();
      } else if (
         (typeof fetchConfig.pageToken === 'undefined' ||
            !fetchConfig.pageToken) &&
         corePricingConfig.joinTableData.length > 0
      )
         toastSuccess(
            `Successfully fetched ${
               !fetchConfig.isStopAPI ? 'all' : ''
            } data.Export data available now`,
            { backgroundColor: '#268440' }
         );
      getTableData({
         joinTable: corePricingConfig.joinTableData,
         primaryTableLength: corePricingConfig.primaryTable.length,
         totalItem: fetchConfig.totalItem,
         isCompleted:
            typeof fetchConfig.pageToken === 'undefined' ? true : false,
      });
   }, [corePricingConfig.pageToken]);

   const emptyValidation = (value) => {
      return value ? value : '';
   };
   const emptyArrayValidation = (value) => {
      return value && value.toString().length > 0 ? value.toString() : '';
   };
   const amountEmptyFieldValidation = (value) => {
      return value ? value : 0;
   };
   const dateFormat = (date) => {
      return DateUtil.formatDate(date, DateUtil.DATE_FORMATS.DD_MMM_YY)
         .toString()
         .toUpperCase();
   };
   const dateTimeFormat = (date) => {
      return DateUtil.formatDate(date, DateUtil.DATE_FORMATS.DD_MMM_YY_TIME)
         .toString()
         .toUpperCase();
   };

   useEffect(() => {
      if (
         fetchConfig.isLoading &&
         !corePricingConfig.isSaveSearchCriteria &&
         (fetchConfig.type === CAMEL_CASE_ACTION.PAGINATION_ACTION ||
            fetchConfig.type === CAMEL_CASE_ACTION.SEARCH_ACTION)
      ) {
         callFetchFaresService();
      }
   }, [fetchConfig.isLoading]);

   const parsingOriginalData = (data) => {
      let primaryData = [];
      let secondaryData = [
         {
            categoryTitle: 'fareValue',
            data: [],
         },
         {
            categoryTitle: 'rule',
            data: [],
         },
         {
            categoryTitle: 'footnote',
            data: [],
         },
         {
            categoryTitle: 'distribution',
            data: [],
         },
         {
            categoryTitle: 'fareClass',
            data: [],
         },
         {
            categoryTitle: 'brand',
            data: [],
         },
         {
            categoryTitle: 'market',
            data: [],
         },
      ];
      if (data && data.length > 0) {
         data.map((item) => {
            const {
               origin,
               destination,
               carrierCode,
               fareClassCode,
               tariffNumber,
               footnoteCode,
               routingNumber,
               vendorChangeCode,
               roundTripIndicator,
               currencyCode,
               fareAmount,
               surchargeAmount,
               yqAmount,
               yrAmount,
               aggregatedTax,
               totalFare,
               cabinCode,
               rbds,
               fareTypeCode,
               dayOfWeekTypeCode,
               seasonTypeCode,
               passengerTypes,
               ticketDesignators,
               footnoteReservationFromDate,
               footnoteReservationToDate,
               footnoteTicketingFromDate,
               footnoteTicketingToDate,
               footnoteOutboundTravelFromDate,
               footnoteOutboundTravelToDate,
               footnoteOutboundTravelCompleteDate,
               footnoteTravelDates,
               footnoteSeasonDates,
               footnoteBlackOutDates,
               traveldate,
               ruleNumber,
               dow,
               ruleSeasonDates,
               advancePurchaseReservation,
               ruleTravelDates,
               applicableDates,
               minStay,
               maxStay,
               ruleBlackOutDates,
               effectiveDate,
               discontinueDate,
               receivedDate,
               minstayNumber,
               minstaydayofweeksurcharges,
               gfsUniqueFillingCode,
               gfsDate,
               origincountrycode,
               desiginationcountrycode,
               market,
               brand,
               branddetails,
               status,
               dgNumber,
               userActionCode,
            } = item;

            const primary = {
               org: origin,
               des: destination,
               cxr: carrierCode,
               fbc: fareClassCode,
               tar: tariffNumber,
               ft: emptyValidation(footnoteCode),
               rtg: routingNumber,
            };
            const fareValue = {
               vcc: emptyValidation(vendorChangeCode),
               owrt: emptyValidation(roundTripIndicator),
               cur: emptyValidation(currencyCode),
               amt: amountEmptyFieldValidation(fareAmount),
               sur: surchargeAmount,
               yq: yqAmount,
               yr: yrAmount,
               tax: aggregatedTax,
               ttl: amountEmptyFieldValidation(totalFare),
            };
            const footnote = {
               'fst res': emptyArrayValidation(footnoteReservationFromDate),
               'lst res': emptyArrayValidation(footnoteReservationToDate),
               'fst tkt': emptyArrayValidation(footnoteTicketingFromDate),
               'lst tkt': emptyArrayValidation(footnoteTicketingToDate),
               'tvl st': emptyArrayValidation(footnoteOutboundTravelFromDate),
               'tvl end': emptyArrayValidation(footnoteOutboundTravelToDate),
               'tvl cmplt': emptyArrayValidation(
                  footnoteOutboundTravelCompleteDate
               ),
               'ft tvl dt': emptyArrayValidation(footnoteTravelDates),
               'ft seas dt': emptyArrayValidation(footnoteSeasonDates),
               'ft bo dt': emptyArrayValidation(footnoteBlackOutDates),
            };
            const fareClass = {
               cab: emptyValidation(cabinCode),
               rbd: emptyValidation(rbds),
               ftc: emptyValidation(fareTypeCode),
               'dow tc': emptyValidation(dayOfWeekTypeCode),
               'seas tc': emptyValidation(seasonTypeCode),
               ptc: emptyValidation(passengerTypes),
               'tkt dsg': emptyValidation(ticketDesignators),
            };
            const rule = {
               rule: emptyValidation(ruleNumber),
               dow: dow,
               'seas dt': emptyValidation(ruleSeasonDates),
               ap: advancePurchaseReservation,
               'rule tvl dt': emptyValidation(ruleTravelDates),
               'appl dt': emptyValidation(applicableDates),
               'min st': minStay,
               'max st': maxStay,
               'bo dt': emptyValidation(ruleBlackOutDates),
            };
            const marketDetails = {
               oc: emptyValidation(origincountrycode),
               dc: emptyValidation(desiginationcountrycode),
               mkt: emptyValidation(market),
            };
            const brandDetails = {
               brd: emptyValidation(brand),
               'brd det': emptyValidation(branddetails),
            };
            const distribution = {
               'eff dt': dateFormat(emptyValidation(effectiveDate)),
               'disc dt': emptyValidation(discontinueDate),
               'rec dt': receivedDate
                  ? dateTimeFormat(emptyValidation(receivedDate))
                  : '',
               gfs: emptyValidation(gfsUniqueFillingCode),
               'gfs dt': emptyValidation(gfsDate),
               status: emptyValidation(status),
               dg: emptyValidation(dgNumber),
               uac: emptyValidation(userActionCode),
            };

            secondaryData[0].data.push(fareValue);
            secondaryData[1].data.push(rule);
            secondaryData[2].data.push(footnote);
            secondaryData[3].data.push(distribution);
            secondaryData[4].data.push(fareClass);
            secondaryData[5].data.push(brandDetails);
            secondaryData[6].data.push(marketDetails);
            primaryData.push(primary);
         });
         const primaryHeader = calculateHeader(
            primaryData[0],
            SCREEN_NAMES.FARES
         );
         const parsingData = calculateParsingData(secondaryData);
         const secondaryHeader = calculateHeader(
            parsingData.tableData,
            SCREEN_NAMES.FARES
         );
         const sepratorCaption =
            calculateSeprationTableCaption(secondaryHeader);
         const joinHeaders = [...primaryHeader, ...secondaryHeader];
         const splitingObjects = calculateJoinData(
            primaryData,
            parsingData.mergedSecondaryTable
         );
         const result = generationgTableObjects(splitingObjects);
         const finalPrimaryCollection =
            fetchConfig.type !== CAMEL_CASE_ACTION.SEARCH_ACTION
               ? corePricingConfig.primaryTable.concat(result.primaryCollection)
               : result.primaryCollection;
         const finalSecondaryCollection =
            fetchConfig.type !== CAMEL_CASE_ACTION.SEARCH_ACTION
               ? corePricingConfig.secondaryTable.concat(
                    result.secondaryCollection
                 )
               : result.secondaryCollection;
         calculateResultDetails(finalPrimaryCollection, primaryHeader);
         calculateResultDetails(finalSecondaryCollection, secondaryHeader);
         setCorePricingConfig({
            ...corePricingConfig,
            joinTableHeaders: joinHeaders,
            sepratorCaption: sepratorCaption,
            joinTableData:
               fetchConfig.type !== CAMEL_CASE_ACTION.SEARCH_ACTION
                  ? corePricingConfig.joinTableData.concat(
                       result.fullCollection
                    )
                  : result.fullCollection,
            primaryHeaderDetails: primaryHeader,
            secondaryHeaderDetails: secondaryHeader,
            primaryTable: finalPrimaryCollection,
            secondaryTable: finalSecondaryCollection,
            selectedTab: TOOL_BAR_BUTTONS[0].KEY,
            titleDetails: parsingData.tableTitle,
            pageToken: fetchConfig.pageToken,
         });
      } else if (data?.length === 0) {
         setCorePricingConfig({
            ...corePricingConfig,
            pageToken: fetchConfig.pageToken,
         });
      }
      primaryData = [];
      secondaryData = [
         {
            categoryTitle: 'fareValue',
            data: [],
         },
         {
            categoryTitle: 'rule',
            data: [],
         },
         {
            categoryTitle: 'footnote',
            data: [],
         },
         {
            categoryTitle: 'distribution',
            data: [],
         },
         {
            categoryTitle: 'fareClass',
            data: [],
         },
         {
            categoryTitle: 'brand',
            data: [],
         },
         {
            categoryTitle: 'market',
            data: [],
         },
      ];
   };
   useEffect(() => {
      if (parseInt(fetchConfig.totalItem) !== 0)
         parsingOriginalData(fetchConfig.data);
      else {
         setCorePricingConfig({
            ...corePricingConfig,
            joinTableHeaders: [],
            sepratorCaption: 0,
            joinTableData: [],
            primaryHeaderDetails: [],
            secondaryHeaderDetails: [],
            primaryTable: [],
            secondaryTable: [],
            selectedTab: TOOL_BAR_BUTTONS[0].KEY,
            titleDetails: [],
         });
      }
   }, [fetchConfig.data]);

   const parsingRequestData = (...parsingData) => {
      isEmptyValue = false;
      const isAnyEmptyObject = [];
      let defaultParsingData = parsingData;
      const newOriginalObject = {};
      const removedList = getClonedCopyCollections(
         defaultParsingData[0]
      ).filter((list) => {
         const subListResult = list.categoryDetails.filter((sublist) => {
            if (sublist.values.length > 0) {
               isEmptyValue = sublist.values.some(
                  (item) => item === 'Invalid date' || item.trim() === ''
               );
               if (!isEmptyValue) return sublist;
            }
         });
         if (subListResult.length > 0) {
            list.categoryDetails = subListResult;
            return list;
         }
      });
      removedList.filter((item) => {
         newOriginalObject[
            item.categoryName.toString().charAt(0).toLowerCase() +
               item.categoryName.slice(1).split(' ').join('') +
               (item.categoryName !== 'Fare Class' ? 's' : '')
         ] = [...item.categoryDetails];
      });
      if (Object.values(newOriginalObject).length === 0) isEmptyValue = true;
      else isEmptyValue = false;
      return newOriginalObject;
   };

   const deleteItems = ({ ...result }) => {
      Object.keys(result).map((list) => {
         const rowItems = result[list].map((item) => {
            const defaultItems = { ...item };
            delete defaultItems.keyCode;
            delete defaultItems.title;
            defaultItems.value = defaultItems.values.toString().toUpperCase();
            delete defaultItems.values;
            return (item = defaultItems);
         });
         result[list] = rowItems;
      });
      return result;
   };
   const searchCriteriaParsing = (searchCriteriaConfig) => {
      const getSearchDetails = [...searchCriteriaConfig];
      const filterRecords = getSearchDetails.filter(
         (list) =>
            list.categoryName !== 'Table' &&
            list.categoryName !== 'Products' &&
            list.categoryName !== 'Market'
      );
      let isTariffNumber = false;
      let isReceivedDate = true;
      filterRecords.map((list) => {
         if (
            list.categoryName === 'Identifier' ||
            list.categoryName === 'Distribution'
         ) {
            if (list.categoryDetails.length > 0) {
               list.categoryDetails.map((subList) => {
                  if (
                     (subList.key === 'tariffNumber' ||
                        subList.key === 'transmissionDateTime') &&
                     subList.values.length > 0
                  ) {
                     subList.values.map((value) => {
                        if (value && subList.key === 'tariffNumber')
                           isTariffNumber = true;
                        else if (
                           value &&
                           subList.key === 'transmissionDateTime'
                        ) {
                           isReceivedDate = moment(
                              value,
                              DateUtil.DATE_FORMATS.DD_MMM_YY_TIME,
                              true
                           ).isValid();
                        }
                     });
                  }
               });
            }
         }
      });
      if (!isReceivedDate) {
         toastWarn(
            `Received ${NOTIFICATION_MESSAGES.INVALID_DATE_TIME_FORMAT}`
         );
         return;
      }
      const result = parsingRequestData(filterRecords);
      const updatedData = deleteItems(result);
      updatedData.hostCarrier = sessionStorage.getItem('carrierCode');
      updatedData.pageToken = null;
      updatedData.jobId = null;
      if (!isEmptyValue) {
         if (!isTariffNumber)
            toastWarn(NOTIFICATION_MESSAGES.EMPTY_TARIFF_VALUE);
         else {
            setFetchConfig({
               ...fetchConfig,
               data: [],
               isLoading: true,
               error: '',
               requestedData: updatedData,
               type: CAMEL_CASE_ACTION.SEARCH_ACTION,
               pageToken: updatedData.pageToken,
               jobId: updatedData.jobId,
               isStopAPI: false,
            });
            setCorePricingConfig({
               ...corePricingConfig,
               isLeftSideLayoutOpen: false,
               joinTableHeaders: [],
               sepratorCaption: 0,
               joinTableData: [],
               primaryHeaderDetails: [],
               secondaryHeaderDetails: [],
               primaryTable: [],
               secondaryTable: [],
               selectedTab: TOOL_BAR_BUTTONS[0].KEY,
               titleDetails: [],
            });
            setStopApiRequest(false);
         }
      } else toastWarn(NOTIFICATION_MESSAGES.EMPTY_TARIFF_VALUE);
   };
   const handleUpdateSearchCriteriaConfigClick = async (
      searchCriteriaConfig
   ) => {
      const faresConfig = searchCriteriaConfig.filter((category) =>
         category.screen.includes(SCREEN_NAMES.FARES)
      );

      if (fetchConfig.isLoading) {
         setAbort({
            isAbort: true,
            searchCriteriaDetails: faresConfig,
         });
         setCorePricingConfig({
            ...corePricingConfig,
            joinTableHeaders: [],
            sepratorCaption: 0,
            joinTableData: [],
            primaryHeaderDetails: [],
            secondaryHeaderDetails: [],
            primaryTable: [],
            secondaryTable: [],
            selectedTab: TOOL_BAR_BUTTONS[0].KEY,
            titleDetails: [],
         });
      } else {
         searchCriteriaParsing(faresConfig);
      }
   };
   const handleStopSearchRequest = () => {
      if (typeof fetchConfig.pageToken === 'undefined') return;
      if (cancelToken) {
         cancelToken.cancel('Query canceled');
         setCancelToken(null);
         setStopApiRequest(true);
      }
   };
   const updateTariffNumber = (isAvailable) => {
      setIsTariffNumberAvailable(isAvailable);
   };
   const showWarning = (message) => {
      toastWarn(message);
   };

   const searchCriteriaComponent = () => {
      return (
         <SearchCriteria
            currentScreen={SCREEN_NAMES.FARES}
            showWarning={showWarning}
            getSearchCriteria={getSearchCriteria}
            isTariffNumberAvailable={isTariffNumberAvailable}
            data={searchCriteriaConfig}
            updateTariffNumber={updateTariffNumber}
            handleSearchCriteriaSearch={handleUpdateSearchCriteriaConfigClick}
            handleStopSearchRequest={() => handleStopSearchRequest()}
         />
      );
   };
   const getClonedCopyCollections = (list) => {
      return list.map((item) => {
         return { ...item };
      });
   };

   const updateRecords = (item, totalList) => {
      let currentRecord = 0;
      const updatedResult = totalList.map((list) => {
         if (list.key === item.key) {
            if (item.isDefault || item.isDecending) {
               list.isAscending = true;
               list.isDefault = false;
               list.isDecending = false;
            } else if (item.isAscending) {
               list.isDecending = true;
               list.isAscending = false;
            }
            currentRecord = list;
         }

         return list;
      });
      return { updatedResult, currentRecord };
   };
   const handleSorting = (item) => {
      const primaryTableObject = updateRecords(
         item,
         corePricingConfig.primaryHeaderDetails
      );
      const secondaryTableObject = updateRecords(
         item,
         corePricingConfig.secondaryHeaderDetails
      );
      const currentRecord = primaryTableObject.currentRecord
         ? primaryTableObject.currentRecord
         : secondaryTableObject.currentRecord;
      const primaryTableHeader = primaryTableObject.updatedResult;
      const secondaryTableHeader = secondaryTableObject.updatedResult;
      const resultData = calculateJoinData(
         corePricingConfig.primaryTable,
         corePricingConfig.secondaryTable
      );
      let sortedData;
      sortedData = resultData.sort((a, b) => {
         const NUMERIC_FIELD = [
            'tar',
            'rtg',
            'owrt',
            'amt',
            'sur',
            'yq',
            'yr',
            'tax',
            'ttl',
            'ap',
            'min st',
            'max st',
         ];
         const ALPHA_NUMERIC_WITH_SPECIAL_FIELDS = [
            'fbc',
            'dow',
            'seas dt',
            'appl dt',
            'ft tvl dt',
            'ft bo dt',
            'ft seas dt',
            'bo dt',
            'rule tvl dt',
         ];
         const DATE_FIELD = [
            'fst res',
            'lst res',
            'fst tkt',
            'lst tkt',
            'tvl st',
            'tvl end',
            'tvl cmplt',
            'eff dt',
            'disc dt',
            'gfs dt',
            'rec dt',
         ];
         if (
            !NUMERIC_FIELD.includes(item.key) &&
            !parseInt(a[currentRecord.key]) &&
            !DATE_FIELD.includes(item.key) &&
            !ALPHA_NUMERIC_WITH_SPECIAL_FIELDS.includes(item.key)
         ) {
            return b[currentRecord.key]
               .toString()
               .localeCompare(a[currentRecord.key].toString());
         } else if (
            ALPHA_NUMERIC_WITH_SPECIAL_FIELDS.includes(item.key) &&
            !DATE_FIELD.includes(item.key)
         ) {
            return a[currentRecord.key]
               ?.toString()
               .localeCompare(b[currentRecord.key]?.toString());
         } else if (!DATE_FIELD.includes(item.key)) {
            return parseInt(a[currentRecord.key] - b[currentRecord.key]);
         } else {
            var previousDate = new Date(a[currentRecord.key]),
               nextDate = new Date(b[currentRecord.key]);
            if (!a[currentRecord.key] && b[currentRecord.key]) return 1;
            else if (a[currentRecord.key] && !b[currentRecord.key]) return -1;
            else if (previousDate === nextDate) return 0;
            else
               return previousDate > nextDate
                  ? 1
                  : nextDate > previousDate
                  ? -1
                  : 0;
         }
      });
      const sortedResult = currentRecord.isAscending
         ? sortedData
         : sortedData.reverse();

      const result = generationgTableObjects(sortedResult);
      setCorePricingConfig({
         ...corePricingConfig,
         primaryHeaderDetails: primaryTableObject.updatedResult,
         secondaryHeaderDetails: secondaryTableObject.updatedResult,
         primaryTable: result.primaryCollection,
         secondaryTable: result.secondaryCollection,
         selectedRowDetails: {
            currentRow: corePricingConfig.selectedRowDetails.currentRow,
            selectedCellIndex:
               corePricingConfig.selectedRowDetails.selectedCellIndex,
            selectedCellTableType: CAMEL_CASE_TYPES.PRIMARY_TABLE,
            selectedRowIndex:
               corePricingConfig.selectedRowDetails.selectedRowIndex,
         },
      });
   };

   const updateData = (totalList, item, type, value) => {
      const updatedResult = totalList.map((list) => {
         if (type === 'sorting') {
            if (list.key === item.key) {
               list.isShowFilterControls = !list.isShowFilterControls;
            } else {
               list.isFilterOpen = false;
               list.isShowFilterControls = false;
            }
         } else if (type === 'filterChanging') {
            if (list.key === item.key) {
               list.filterValue = value;
               list.isFilterApply = value ? true : false;
            } else {
               list.filterValue = list.filterValue ? list.filterValue : '';
               list.isFilterApply = list.filterValue ? true : false;
            }
         } else if (type === 'closePopup' && list.key === item.key) {
            list.isFilterOpen = false;
            list.isShowFilterControls = false;
         } else {
            if (list.key === item.key) list.isFilterOpen = true;
            else list.isFilterOpen = false;
         }
         return list;
      });
      return updatedResult;
   };
   const handleFilterChange = (value, item, totalList) => {
      setTimeout(() => {
         let finalResult = corePricingConfig.joinTableData.filter((list) => {
            if (
               list[item.key].toString().includes(value) ||
               list[item.key].toString().includes(value.toUpperCase()) ||
               list[item.key].toString().includes(value.toLowerCase())
            ) {
               return list;
            }
         });
         const primaryHeader = updateData(
            corePricingConfig.primaryHeaderDetails,
            item,
            'filterChanging',
            value
         );
         const secondaryHeader = updateData(
            corePricingConfig.secondaryHeaderDetails,
            item,
            'filterChanging',
            value
         );
         const mergedHeaders = [...primaryHeader, ...secondaryHeader];
         mergedHeaders.map((list) => {
            if (list.filterValue && item.key !== list.key) {
               finalResult = finalResult.filter((subList) => {
                  if (subList[list.key].toString().includes(list.filterValue)) {
                     return subList;
                  }
               });
            }
         });

         const result = generationgTableObjects(finalResult);
         if (finalResult.length > 0) {
            setCorePricingConfig({
               ...corePricingConfig,
               primaryHeaderDetails: primaryHeader,
               secondaryHeaderDetails: secondaryHeader,
               primaryTable: result.primaryCollection,
               secondaryTable: result.secondaryCollection,
            });
         } else if (finalResult.length === 0 && value) {
            setCorePricingConfig({
               ...corePricingConfig,
               primaryTable: [],
               secondaryTable: [],
            });
         } else if (!value) {
            setCorePricingConfig({
               ...corePricingConfig,
               primaryHeaderDetails: primaryHeader,
               secondaryHeaderDetails: secondaryHeader,
               primaryTable: result.primaryCollection,
               secondaryTable: result.secondaryCollection,
            });
         }
      }, 0);
   };
   const handleEnablesPrimaryHeadersControls = (
      item,
      list,
      isSecondaryTable,
      isSorting,
      type
   ) => {
      if (type === 'openPopup') {
         const primaryHeader = isSecondaryTable
            ? updateData(
                 corePricingConfig.primaryHeaderDetails,
                 item,
                 isSorting ? 'sorting' : 'filtering'
              )
            : updateData(list, item, isSorting ? 'sorting' : 'filtering');
         const secondaryHeader = isSecondaryTable
            ? updateData(list, item, isSorting ? 'sorting' : 'filtering')
            : updateData(
                 corePricingConfig.secondaryHeaderDetails,
                 item,
                 isSorting ? 'sorting' : 'filtering'
              );
         setCorePricingConfig({
            ...corePricingConfig,
            primaryHeaderDetails: primaryHeader,
            secondaryHeaderDetails: secondaryHeader,
         });
      } else if (type === 'closeHeader' && !item.isFilterOpen) {
         const primaryHeader = isSecondaryTable
            ? updateData(
                 corePricingConfig.primaryHeaderDetails,
                 item,
                 'closePopup'
              )
            : updateData(list, item, 'closePopup');
         const secondaryHeader = isSecondaryTable
            ? updateData(list, item, 'closePopup')
            : updateData(
                 corePricingConfig.secondaryHeaderDetails,
                 item,
                 'closePopup'
              );
         setCorePricingConfig({
            ...corePricingConfig,
            primaryHeaderDetails: primaryHeader,
            secondaryHeaderDetails: secondaryHeader,
         });
      } else if (type !== 'closeHeader' && item.isFilterOpen) {
         const primaryHeader = isSecondaryTable
            ? updateData(
                 corePricingConfig.primaryHeaderDetails,
                 item,
                 'closePopup'
              )
            : updateData(list, item, 'closePopup');
         const secondaryHeader = isSecondaryTable
            ? updateData(list, item, 'closePopup')
            : updateData(
                 corePricingConfig.secondaryHeaderDetails,
                 item,
                 'closePopup'
              );
         setCorePricingConfig({
            ...corePricingConfig,
            primaryHeaderDetails: primaryHeader,
            secondaryHeaderDetails: secondaryHeader,
         });
      }
   };

   const handleUniqueItemClick = (item, isScroll) => {
      let result = [];
      if (!isScroll) {
         result = corePricingConfig.primaryHeaderDetails.map((list) => {
            list.uniqueFilters.map((subList) => {
               if (subList.key === item.key) subList.value = !subList.value;
               return subList;
            });
            return list;
         });
      } else {
         result = corePricingConfig.secondaryHeaderDetails.map((list) => {
            list.uniqueFilters.map((subList) => {
               if (subList.key === item.key) subList.value = !subList.value;
               return subList;
            });
            return list;
         });
      }
      setCorePricingConfig({
         ...corePricingConfig,
         primaryHeaderDetails: !isScroll
            ? result
            : corePricingConfig.primaryHeaderDetails,
         secondaryHeaderDetails: !isScroll
            ? corePricingConfig.secondaryHeaderDetails
            : result,
         joinHeaders: !isScroll
            ? [...result, ...corePricingConfig.secondaryHeaderDetails]
            : [...corePricingConfig.primaryHeaderDetails, ...result],
      });
   };
   const handlePrimaryTableScroll = (event) => {
      if (secondaryTableReference.current)
         secondaryTableReference.current.scrollTop = event.target.scrollTop;

      let bottom =
         event.target.scrollHeight -
            event.target.scrollTop -
            event.target.clientHeight <
         50;
      if (bottom) {
         const updateRequest = fetchConfig.requestedData;
      }
      const isFilterPopupOpen = [
         ...corePricingConfig.primaryHeaderDetails,
         ...corePricingConfig.secondaryHeaderDetails,
      ].some((list) => list.isFilterOpen);
      if (isFilterPopupOpen) return;
   };
   const handleSecondaryTableScroll = (event) => {
      if (primaryTableReference.current)
         primaryTableReference.current.scrollTop = event.target.scrollTop;
      const isFilterPopupOpen = [
         ...corePricingConfig.primaryHeaderDetails,
         ...corePricingConfig.secondaryHeaderDetails,
      ].some((list) => list.isFilterOpen);
      if (isFilterPopupOpen) return;
   };
   const handleSelectAllUpdate = (isSelectAll, isScroll, item) => {
      let result = [];
      if (!isScroll) {
         result = corePricingConfig.primaryHeaderDetails.map((list) => {
            list.uniqueFilters.map((subList) => {
               if (list.key === item.key)
                  subList.value = !isSelectAll ? false : true;
               return subList;
            });
            return list;
         });
      } else {
         result = corePricingConfig.secondaryHeaderDetails.map((list) => {
            list.uniqueFilters.map((subList) => {
               if (list.key === item.key)
                  subList.value = !isSelectAll ? false : true;
               return subList;
            });
            return list;
         });
      }
      setCorePricingConfig({
         ...corePricingConfig,
         primaryHeaderDetails: !isScroll
            ? result
            : corePricingConfig.primaryHeaderDetails,
         secondaryHeaderDetails: !isScroll
            ? corePricingConfig.secondaryHeaderDetails
            : result,
         joinHeaders: !isScroll
            ? [...result, ...corePricingConfig.secondaryHeaderDetails]
            : [...corePricingConfig.primaryHeaderDetails, ...result],
      });
   };
   const calculateResultDetailsUnique = (collection, headers, item, type) => {
      headers.map((menuList) => {
         const uniqueResult = [
            ...new Set(
               collection.map(
                  (list) => list[menuList.key] && list[menuList.key].toString()
               )
            ),
         ];
         uniqueResult.sort();
         if (menuList.key !== item.key) {
            const response = uniqueResult.map((item) => {
               return {
                  key: item,
                  value: true,
               };
            });
            menuList.uniqueFilters = getClonedCopyCollections(response);
         } else if (type === 'clear' && menuList.key === item.key) {
            const response = menuList.uniqueFilters.filter((subItem) =>
               uniqueResult.includes(subItem.key)
            );
            menuList.uniqueFilters = getClonedCopyCollections(response);
         }
      });
      return headers;
   };

   const handleFilterUniqueItems = (item, isSecondaryTable, type) => {
      setCorePricingConfig({
         ...corePricingConfig,
         isFilterApply: true,
      });
      setTimeout(() => {
         const filterTableData = corePricingConfig.joinTableData;
         let filterTableHeader = [
            ...corePricingConfig.primaryHeaderDetails,
            ...corePricingConfig.secondaryHeaderDetails,
         ];
         let filterFinalTableCollection = [];

         filterTableHeader.forEach((list, index) => {
            if (type === 'clear') {
               if (list.key === item.key) {
                  list.uniqueFilters = getClonedCopyCollections(
                     corePricingConfig.joinTableHeaders[index]
                        .defaultuniqueFilters
                  );
                  list.uniqueFilters.map((subList) => (subList.value = true));
                  list.width =
                     item.key === 'cur' ||
                     item.key === 'amt' ||
                     item.key === 'sur' ||
                     item.key === 'yq' ||
                     item.key === 'yr'
                        ? item.width - 100
                        : item.key === 'owrt'
                        ? item.width - 100
                        : item.key === 'ft'
                        ? item.width - 70
                        : item.width - 50;
                  list.isFilterApply = false;
               }
            }
            if (list.uniqueFilters.every((item) => item.value === true)) {
               list.uniqueFilters = !list.isFilterApply
                  ? getClonedCopyCollections(
                       corePricingConfig.joinTableHeaders[index]
                          .defaultuniqueFilters
                    )
                  : getClonedCopyCollections(list.uniqueFilters);
            }
            if (list.key === item.key && type === 'Apply') {
               list.width =
                  item.key === 'cur' ||
                  item.key === 'amt' ||
                  item.key === 'sur' ||
                  item.key === 'yq' ||
                  item.key === 'yr'
                     ? item.width - 100
                     : item.key === 'owrt'
                     ? item.width - 100
                     : item.key === 'ft'
                     ? item.width - 70
                     : item.width - 50;
               list.isFilterApply = true;
            }
            if (!list.isFilterApply) {
               list.uniqueFilters.map((subList) => (subList.value = true));
            }
            return list;
         });
         filterTableData.filter((list) => {
            let unSelectionColumn = [];
            let currentRecordTableKeys = Object.keys(list);
            let currentRecordUpdatedTableKeys = currentRecordTableKeys.filter(
               (item) =>
                  item !== 'id' &&
                  item !== 'isSelect' &&
                  item !== 'selectedField' &&
                  item !== 'selectedColumn'
            );
            currentRecordUpdatedTableKeys.filter(
               (item, subIndex, filterCollection) => {
                  const uniqueValueList = filterTableHeader.find(
                     (header) => header.key === item
                  );
                  if (uniqueValueList) {
                     const matchRecords =
                        uniqueValueList?.uniqueFilters?.length > 0 &&
                        uniqueValueList?.uniqueFilters?.find(
                           (secList) =>
                              secList.value === true &&
                              ((secList.key.toString() === 'null' &&
                                 (!list[item].toString() ||
                                    list[item].toString() === '|')) ||
                                 list[item]?.toString() ===
                                    secList.key.toString())
                        );
                     if (!matchRecords) unSelectionColumn.push(item);
                     if (subIndex === filterCollection.length - 1) {
                        if (unSelectionColumn.length === 0)
                           filterFinalTableCollection.push(list);
                     }
                  }
               }
            );
         });
         const result = generationgTableObjects(filterFinalTableCollection);
         const primaryHeaderDetails = updateData(
            corePricingConfig.primaryHeaderDetails,
            item,
            'closePopup'
         );
         const secondaryHeaderDetails = updateData(
            corePricingConfig.secondaryHeaderDetails,
            item,
            'closePopup'
         );
         calculateResultDetailsUnique(
            result.primaryCollection,
            primaryHeaderDetails,
            item,
            type
         );
         calculateResultDetailsUnique(
            result.secondaryCollection,
            secondaryHeaderDetails,
            item,
            type
         );

         setCorePricingConfig({
            ...corePricingConfig,
            primaryHeaderDetails: primaryHeaderDetails,
            secondaryHeaderDetails: secondaryHeaderDetails,
            primaryTable: result.primaryCollection,
            secondaryTable: result.secondaryCollection,
            isFilterApply: false,
         });
      }, 0);
   };
   const handleClearEvent = (item, list, isSecondaryTable) => {
      handleFilterUniqueItems(item, isSecondaryTable, 'clear');
   };
   const handleRecordClick = (
      selectedList,
      selectedItem,
      selectedColumn,
      isShiftKeyPress,
      currentIndex,
      collection,
      type
   ) => {
      if (type === 'otherKey') {
         if (!isShiftKeyPress) {
            const currentTableData = calculateJoinData(
               corePricingConfig.primaryTable,
               corePricingConfig.secondaryTable
            );
            const updateResult = getClonedCopyCollections(currentTableData).map(
               (list) => {
                  if (list.id === selectedList.id) {
                     list.isSelect = true;
                     list.selectedField = selectedItem;
                     list.selectedColumn = selectedColumn;
                  } else {
                     list.isSelect = false;
                     list.selectedField = '';
                     list.selectedColumn = '';
                  }
                  return list;
               }
            );
            if (selectedItem && selectedColumn) {
               const result = generationgTableObjects(updateResult);
               setCorePricingConfig({
                  ...corePricingConfig,
                  primaryTable: result.primaryCollection,
                  secondaryTable: result.secondaryCollection,
               });
            }
         } else {
            let updateResult = [];
            const existingIndex = collection.findIndex((list) => list.isSelect);
            const currentTableData = calculateJoinData(
               corePricingConfig.primaryTable,
               corePricingConfig.secondaryTable
            );
            if (existingIndex > currentIndex) {
               updateResult = getClonedCopyCollections(currentTableData).map(
                  (list, index) => {
                     if (index >= currentIndex && index <= existingIndex)
                        list.isSelect = true;
                     return list;
                  }
               );
            } else {
               updateResult = getClonedCopyCollections(currentTableData).map(
                  (list, index) => {
                     if (index >= existingIndex && index <= currentIndex)
                        list.isSelect = true;
                     return list;
                  }
               );
            }
            const result = generationgTableObjects(updateResult);
            setCorePricingConfig({
               ...corePricingConfig,
               primaryTable: result.primaryCollection,
               secondaryTable: result.secondaryCollection,
            });
         }
      } else {
         const currentTableData = calculateJoinData(
            corePricingConfig.primaryTable,
            corePricingConfig.secondaryTable
         );
         const updateResult = getClonedCopyCollections(currentTableData).map(
            (list) => {
               if (list.id === selectedList.id) {
                  list.isSelect = type === 'ctrlKey' ? !list.isSelect : true;
                  list.selectedField = selectedItem;
                  list.selectedColumn = selectedColumn;
               }
               return list;
            }
         );
         const result = generationgTableObjects(updateResult);
         setCorePricingConfig({
            ...corePricingConfig,
            primaryTable: result.primaryCollection,
            secondaryTable: result.secondaryCollection,
         });
      }
   };

   const handleKeyPressEvent = (
      selectedList,
      selectedItem,
      selectedColumn,
      keyCode,
      currentIndex,
      collection,
      type
   ) => {
      let newDataSelection = {};
      if (type === 'singleSelection')
         currentIndex = collection.findIndex((list) => list.isSelect);
      else if (selectedList.isSelect)
         currentIndex = collection.findIndex(
            (list) => list.id === selectedList.id
         );
      if (type === 'multiSelection') {
         if (
            (keyCode === 38 || keyCode === 40) &&
            collection.filter((list) => list.isSelect).length === 1
         ) {
            newDataSelection =
               keyCode === 38
                  ? collection[currentIndex - 1]
                  : collection[currentIndex + 1];
         } else {
            const latestUpdateData =
               keyCode === 38
                  ? collection.find((list) => list.isSelect)
                  : collection.findLast((list) => list.isSelect);
            const latestIndex = collection.findIndex(
               (list) => list.id === latestUpdateData.id
            );
            if (
               (currentIndex > latestIndex && keyCode === 38) ||
               (currentIndex < latestIndex && keyCode === 40)
            )
               newDataSelection =
                  keyCode === 38
                     ? collection[latestIndex - 1]
                     : collection[latestIndex + 1];
            else {
               const latestUpdateData =
                  keyCode === 40
                     ? collection.find((list) => list.isSelect)
                     : collection.findLast((list) => list.isSelect);
               const latestIndex = collection.findIndex(
                  (list) => list.id === latestUpdateData.id
               );
               newDataSelection = collection[latestIndex];
            }
         }
      } else if (type === 'singleSelection') {
         newDataSelection =
            keyCode === 38
               ? collection[currentIndex - 1]
               : collection[currentIndex + 1];
      }

      if (newDataSelection) {
         const currentTableData = calculateJoinData(
            corePricingConfig.primaryTable,
            corePricingConfig.secondaryTable
         );
         const updateResult = getClonedCopyCollections(currentTableData).map(
            (list) => {
               if (type === 'multiSelection') {
                  if (list.id === newDataSelection.id) {
                     list.isSelect = !list.isSelect;
                  }
               } else if (type === 'singleSelection') {
                  if (list.id === newDataSelection.id) {
                     list.isSelect = true;
                     list.selectedField = selectedItem;
                     list.selectedColumn = selectedColumn;
                     document.getElementById(list.id).focus();
                  } else {
                     list.isSelect = false;
                     list.selectedField = '';
                     list.selectedColumn = '';
                  }
               }
               return list;
            }
         );
         const result = generationgTableObjects(updateResult);
         if (selectedItem && selectedColumn) {
            setCorePricingConfig({
               ...corePricingConfig,
               primaryTable: result.primaryCollection,
               secondaryTable: result.secondaryCollection,
               joinTableData: result.fullCollection,
            });
         }
      }
   };

   const navigationPagination = () => {
      const totalItems = parseInt(fetchConfig.totalItem);
      if (
         fetchConfig.totalItem &&
         totalItems !== corePricingConfig.primaryTable.length
      ) {
         if (fetchConfig.data.length !== parseInt(fetchConfig.totalItem))
            setFetchConfig({
               ...fetchConfig,
               requestedData: fetchConfig.requestedData,
               isLoading: true,
               type: CAMEL_CASE_ACTION.PAGINATION_ACTION,
               error: '',
            });
      }
   };
   const handleScroll = (event, type) => {
      if (
         primaryTableReference?.current?.Grid?.state?.scrollTop ===
            event.scrollTop ||
         secondaryTableReference?.current?.scrollHeight === event.scrollTop
      ) {
         return;
      } else if (
         secondaryTableReference.current &&
         type === CAMEL_CASE_TYPES.PRIMARY_TABLE &&
         (secondaryTableReference?.current?.Grid.state.scrollTop ||
            secondaryTableReference?.current?.Grid.state.scrollTop === 0)
      )
         secondaryTableReference.current.scrollToPosition(event.scrollTop);
      else if (
         primaryTableReference.current &&
         type === CAMEL_CASE_TYPES.SECONDARY_TABLE &&
         (primaryTableReference?.current?.Grid.state.scrollTop ||
            primaryTableReference?.current?.Grid.state.scrollTop === 0)
      )
         primaryTableReference.current.scrollToPosition(event.scrollTop);
   };
   const getSelectedIndex = (selectedRowDetails) => {
      setCorePricingConfig({
         ...corePricingConfig,
         selectedRowDetails: selectedRowDetails,
      });
   };
   const handleOutSideClick = () => {
      setCorePricingConfig({
         ...corePricingConfig,
         selectedRowDetails: {
            currentRow: corePricingConfig.selectedRowDetails.currentRow,
            selectedCellIndex:
               corePricingConfig.selectedRowDetails.selectedCellIndex,
            selectedCellTableType:
               corePricingConfig.selectedRowDetails.selectedCellTableType,
            selectedRowIndex:
               corePricingConfig.selectedRowDetails.selectedRowIndex,
         },
      });
   };

   const copyDetails = (data) => {
      var newObject = {};
      for (const [key, value] of Object.entries(data)) {
         if (ROW_COPY_ENABLED_FARES_SCREEN_COLUMN.includes(key))
            newObject[`${key}`] = `${value}`;
         else newObject[`${key}`] = '';
      }
      return newObject;
   };
   const copyRow = (
      selectedRowIndex,
      currentIndex,
      type,
      editData,
      isSecondary
   ) => {
      const selectedRows = [];
      if (
         type === CAMEL_CASE_TYPES.TEMPLATE ||
         type === CAMEL_CASE_TYPES.MULTIEDIT
      ) {
         const primaryRecord = [];
         const secondaryRecord = [];
         const joinRecord = [];
         selectedRowIndex.forEach((selectedIndex) => {
            const primaryTemplateData = getClonedCopyCollections([
               corePricingConfig.primaryTable[selectedIndex],
            ]);
            const secondaryTemplateData = getClonedCopyCollections([
               corePricingConfig.secondaryTable[selectedIndex],
            ]);
            const FullTemplateData = getClonedCopyCollections([
               corePricingConfig.joinTableData[selectedIndex],
            ]);
            primaryRecord.push(copyDetails(primaryTemplateData[0]));
            secondaryRecord.push(copyDetails(secondaryTemplateData[0]));
            joinRecord.push(copyDetails(FullTemplateData[0]));
         });
         primaryRecord.forEach((list, index) => {
            const id = uuidv4();
            primaryRecord[index].uac =
               type === CAMEL_CASE_TYPES.TEMPLATE
                  ? USER_ACTION_CODE_FARES_SCREEN.NEW
                  : USER_ACTION_CODE_FARES_SCREEN.UPDATE;
            primaryRecord[index].isInsert = true;
            primaryRecord[index].id = id;
            secondaryRecord[index].uac =
               type === CAMEL_CASE_TYPES.TEMPLATE
                  ? USER_ACTION_CODE_FARES_SCREEN.NEW
                  : USER_ACTION_CODE_FARES_SCREEN.UPDATE;
            secondaryRecord[index].owrt =
               secondaryRecord[index].owrt === '3'
                  ? '1'
                  : secondaryRecord[index].owrt;
            secondaryRecord[index].isInsert = true;
            secondaryRecord[index].id = id;
            secondaryRecord[index]['eff dt'] = dateFormat(todayDate);
            joinRecord[index].uac =
               type === CAMEL_CASE_TYPES.TEMPLATE
                  ? USER_ACTION_CODE_FARES_SCREEN.NEW
                  : USER_ACTION_CODE_FARES_SCREEN.UPDATE;
            joinRecord[index].isInsert = true;
            joinRecord[index].id = id;
            joinRecord[index]['eff dt'] = dateFormat(todayDate);

            corePricingConfig.primaryTable.splice(
               currentIndex,
               0,
               primaryRecord[index]
            );
            corePricingConfig.secondaryTable.splice(
               currentIndex,
               0,
               secondaryRecord[index]
            );
            corePricingConfig.joinTableData.splice(
               currentIndex,
               0,
               joinRecord[index]
            );
            selectedRows.push(id);
         });
         const userActionCodeFilter =
            corePricingConfig.secondaryHeaderDetails.find(
               (headerDetails) => headerDetails.key === 'uac'
            );
         if (
            !userActionCodeFilter.uniqueFilters.some(
               (item) =>
                  item.key === USER_ACTION_CODE_FARES_SCREEN.NEW ||
                  item.key === USER_ACTION_CODE_FARES_SCREEN.UPDATE
            )
         ) {
            corePricingConfig.secondaryHeaderDetails
               .find((headerDetails) => headerDetails.key === 'uac')
               .uniqueFilters.push({
                  key:
                     type === CAMEL_CASE_TYPES.TEMPLATE
                        ? USER_ACTION_CODE_FARES_SCREEN.NEW
                        : USER_ACTION_CODE_FARES_SCREEN.UPDATE,
                  value: true,
               });
         }
         const newRecordIndex = [];
         selectedRows.forEach((id) => {
            newRecordIndex.push(
               corePricingConfig.joinTableData
                  .map((record) => record.id)
                  .indexOf(id)
            );
         });
         setCorePricingConfig({
            ...corePricingConfig,
            selectedRowDetails: {
               currentRow: currentIndex,
               selectedCellIndex:
                  corePricingConfig.selectedRowDetails.selectedCellIndex,
               selectedCellTableType:
                  corePricingConfig.selectedRowDetails.selectedCellTableType,
               selectedRowIndex: newRecordIndex,
            },
         });
         setNewTemplateId(selectedRows);
      } else if (type === CAMEL_CASE_ACTION.CANCEL) {
         selectedRowIndex.map((selectedIndex) => {
            if (!corePricingConfig.primaryTable[selectedIndex].uac) {
               corePricingConfig.primaryTable[selectedIndex].uac =
                  USER_ACTION_CODE_FARES_SCREEN.CLOSE;
               corePricingConfig.primaryTable[selectedIndex].isCancel = true;
               corePricingConfig.secondaryTable[selectedIndex].uac =
                  USER_ACTION_CODE_FARES_SCREEN.CLOSE;
               corePricingConfig.secondaryTable[selectedIndex].isCancel = true;
               corePricingConfig.secondaryTable[selectedIndex]['eff dt'] =
                  dateFormat(todayDate);
               corePricingConfig.secondaryTable[selectedIndex]['disc dt'] =
                  dateFormat(todayDate);
               corePricingConfig.joinTableData[selectedIndex].uac =
                  USER_ACTION_CODE_FARES_SCREEN.CLOSE;
               corePricingConfig.joinTableData[selectedIndex].isCancel = true;
            }
         });
      } else if (type === CAMEL_CASE_ACTION.UNDO) {
         selectedRowIndex.map((selectedIndex) => {
            let currentIndex = -1;
            let isCancel = false;
            corePricingConfig.primaryTable.find((list, index) => {
               if (
                  (list.uac && list.isInsert) ||
                  list.uac === USER_ACTION_CODE_FARES_SCREEN.ERROR
               ) {
                  currentIndex = index;
                  isCancel = false;
               } else if (list.uac && list.isCancel) {
                  currentIndex = index;
                  isCancel = true;
               }
            });
            if (currentIndex >= 0 && !isCancel) {
               corePricingConfig.primaryTable.splice(currentIndex, 1);
               corePricingConfig.secondaryTable.splice(currentIndex, 1);
               corePricingConfig.joinTableData.splice(currentIndex, 1);
            } else if (currentIndex >= 0 && isCancel) {
               delete corePricingConfig.primaryTable[currentIndex].uac;
               delete corePricingConfig.primaryTable[currentIndex].isCancel;
               delete corePricingConfig.secondaryTable[currentIndex].uac;
               delete corePricingConfig.secondaryTable[currentIndex].isCancel;
               delete corePricingConfig.joinTableData[currentIndex].uac;
               delete corePricingConfig.joinTableData[currentIndex].isCancel;
               corePricingConfig.secondaryTable[currentIndex]['eff dt'] =
                  corePricingConfig.joinTableData[currentIndex]['eff dt'];
               corePricingConfig.secondaryTable[currentIndex]['disc dt'] =
                  corePricingConfig.joinTableData[currentIndex]['disc dt'];
            }
         });
      }
      if (type === CAMEL_CASE_TYPES.MULTIEDIT) {
         const newIndex = [];
         selectedRows.forEach((id) => {
            newIndex.push(
               corePricingConfig.primaryTable.findIndex((row) => row.id === id)
            );
         });
         setCorePricingConfig({
            ...corePricingConfig,
            selectedRowDetails: {
               currentRow: newIndex[0],
               selectedCellIndex: 0,
               selectedCellTableType: isSecondary
                  ? CAMEL_CASE_TYPES.SECONDARY_TABLE
                  : CAMEL_CASE_TYPES.PRIMARY_TABLE,
               selectedRowIndex: newIndex,
            },
         });
         handleEditDataUpdated(
            editData.cellData,
            editData,
            isSecondary,
            CAMEL_CASE_TYPES.MULTIEDIT,
            newIndex
         );
      } else if (
         type !== CAMEL_CASE_ACTION.CANCEL &&
         type !== CAMEL_CASE_TYPES.TEMPLATE
      ) {
         setCorePricingConfig({
            ...corePricingConfig,
            insertIndex: currentIndex ? currentIndex : -1,
         });
         setCorePricingConfig({
            ...corePricingConfig,
            selectedRowDetails: {
               currentRow: -2,
               selectedCellIndex: -2,
               selectedCellTableType: isSecondary
                  ? CAMEL_CASE_TYPES.SECONDARY_TABLE
                  : CAMEL_CASE_TYPES.PRIMARY_TABLE,
               selectedRowIndex: [],
            },
         });
      }
   };
   const handleInsertRow = (insertIndex) => {
      const primaryEmptyResult = Object.fromEntries(
         Object.keys(corePricingConfig.primaryTable[0]).map((key) => [key, ''])
      );
      primaryEmptyResult.isInsert = true;
      primaryEmptyResult.uac = primaryEmptyResult.uac
         ? primaryEmptyResult.uac
         : USER_ACTION_CODE_FARES_SCREEN.NEW;
      corePricingConfig.primaryTable.splice(insertIndex, 0, primaryEmptyResult);
      const secondaryEmptyResult = Object.fromEntries(
         Object.keys(corePricingConfig.secondaryTable[0]).map((key) => [
            key,
            '',
         ])
      );
      secondaryEmptyResult.isInsert = true;
      secondaryEmptyResult['eff dt'] = dateFormat(todayDate);
      secondaryEmptyResult.uac = secondaryEmptyResult.uac
         ? secondaryEmptyResult.uac
         : USER_ACTION_CODE_FARES_SCREEN.NEW;
      corePricingConfig.secondaryTable.splice(
         insertIndex,
         0,
         secondaryEmptyResult
      );
      const joinTableEmptyResult = Object.fromEntries(
         Object.keys(corePricingConfig.joinTableData[0]).map((key) => [key, ''])
      );
      joinTableEmptyResult.isInsert = true;
      joinTableEmptyResult.uac = joinTableEmptyResult.uac
         ? joinTableEmptyResult.uac
         : USER_ACTION_CODE_FARES_SCREEN.NEW;
      corePricingConfig.joinTableData.splice(
         insertIndex,
         0,
         joinTableEmptyResult
      );
      setCorePricingConfig({
         ...corePricingConfig,
         insertIndex: insertIndex,
      });
   };
   const updateDoubleClicRows = (updatedRow, item, isEnable, type) => {
      if (type === CAMEL_CASE_ACTION.CANCEL && item.rowData.uac) return;
      corePricingConfig.primaryTable[updatedRow.currentRow].isDoubleClick =
         isEnable;
      corePricingConfig.primaryTable[updatedRow.currentRow].key = item.dataKey;
      corePricingConfig.secondaryTable[updatedRow.currentRow].key =
         item.dataKey;
      corePricingConfig.secondaryTable[updatedRow.currentRow].isDoubleClick =
         isEnable;
      if (item.rowData.uac === USER_ACTION_CODE_FARES_SCREEN.ERROR) {
         corePricingConfig.secondaryTable[updatedRow.currentRow].isInsert =
            isEnable;
         corePricingConfig.primaryTable[updatedRow.currentRow].isInsert =
            isEnable;
         corePricingConfig.joinTableData[updatedRow.currentRow].isInsert =
            isEnable;
         corePricingConfig.secondaryTable[updatedRow.currentRow].isReject =
            !isEnable;
         corePricingConfig.primaryTable[updatedRow.currentRow].isReject =
            !isEnable;
         corePricingConfig.joinTableData[updatedRow.currentRow].isReject =
            !isEnable;
         corePricingConfig.secondaryTable[updatedRow.currentRow].isSave =
            !isEnable;
         corePricingConfig.primaryTable[updatedRow.currentRow].isSave =
            !isEnable;
         corePricingConfig.joinTableData[updatedRow.currentRow].isSave =
            !isEnable;
         corePricingConfig.secondaryTable[updatedRow.currentRow].uac =
            USER_ACTION_CODE_FARES_SCREEN.UPDATE;
         corePricingConfig.primaryTable[updatedRow.currentRow].uac =
            USER_ACTION_CODE_FARES_SCREEN.UPDATE;
         corePricingConfig.joinTableData[updatedRow.currentRow].uac =
            USER_ACTION_CODE_FARES_SCREEN.UPDATE;
      }
   };

   const handleMathOperation = (
      value,
      item,
      isSecondary,
      selectedRowDetails
   ) => {
      if (value[0] === '=' && MATH_OPERATIONS.includes(value[1])) {
         selectedRowDetails.map((itemIndex) => {
            const calculatedValue = eval(
               `{ ${corePricingConfig.joinTableData[itemIndex][item.dataKey]} ${
                  value[1]
               } ${value.slice(2)}}`
            );
            if (!isSecondary) {
               corePricingConfig.primaryTable[itemIndex][item.dataKey] =
                  calculatedValue;
            } else {
               corePricingConfig.secondaryTable[itemIndex][item.dataKey] =
                  calculatedValue;
            }
         });
         setCorePricingConfig({
            ...corePricingConfig,
            insertIndex: item.rowIndex,
         });
         const calculatedValue = eval(
            `{ ${
               corePricingConfig.joinTableData[item.rowIndex][item.dataKey]
            } ${value[1]} ${value.slice(2)}}`
         );
         if (!isSecondary)
            corePricingConfig.primaryTable[item.rowIndex][item.dataKey] =
               calculatedValue;
         else
            corePricingConfig.secondaryTable[item.rowIndex][item.dataKey] =
               calculatedValue;
         return;
      } else if (value[0] !== '=' || !MATH_OPERATIONS.includes(value[1])) {
         showWarning(
            NOTIFICATION_MESSAGES.INVALID_MATH_OPERATION_AMOUNT_FIELD_FORMAT
         );
         return;
      }
   };
   const configureNewRow = () => {
      const id = uuidv4();
      corePricingConfig.primaryTable[
         corePricingConfig.selectedRowDetails.currentRow
      ].isInsert = true;
      corePricingConfig.primaryTable[
         corePricingConfig.selectedRowDetails.currentRow
      ].uac = USER_ACTION_CODE_FARES_SCREEN.UPDATE;
      corePricingConfig.primaryTable[
         corePricingConfig.selectedRowDetails.currentRow
      ].id = id;
      corePricingConfig.primaryTable[
         corePricingConfig.selectedRowDetails.currentRow
      ].isDoubleClick = false;
      corePricingConfig.primaryTable[
         corePricingConfig.selectedRowDetails.currentRow
      ]['eff dt'] = dateFormat(todayDate);
      corePricingConfig.secondaryTable[
         corePricingConfig.selectedRowDetails.currentRow
      ].isDoubleClick = false;
      corePricingConfig.secondaryTable[
         corePricingConfig.selectedRowDetails.currentRow
      ]['eff dt'] = dateFormat(todayDate);
      corePricingConfig.secondaryTable[
         corePricingConfig.selectedRowDetails.currentRow
      ].isInsert = true;
      corePricingConfig.secondaryTable[
         corePricingConfig.selectedRowDetails.currentRow
      ].owrt =
         corePricingConfig.secondaryTable[
            corePricingConfig.selectedRowDetails.currentRow
         ].owrt === '3'
            ? '1'
            : corePricingConfig.secondaryTable[
                 corePricingConfig.selectedRowDetails.currentRow
              ].owrt;
      corePricingConfig.secondaryTable[
         corePricingConfig.selectedRowDetails.currentRow
      ].uac = USER_ACTION_CODE_FARES_SCREEN.UPDATE;
      corePricingConfig.secondaryTable[
         corePricingConfig.selectedRowDetails.currentRow
      ].id = id;
      const tableObjects = generationgTableObjects([
         corePricingConfig.joinTableData[
            corePricingConfig.selectedRowDetails.currentRow
         ],
      ]);
      corePricingConfig.primaryTable.splice(
         corePricingConfig.selectedRowDetails.currentRow + 1,
         0,
         tableObjects.primaryCollection[0]
      );
      corePricingConfig.secondaryTable.splice(
         corePricingConfig.selectedRowDetails.currentRow + 1,
         0,
         tableObjects.secondaryCollection[0]
      );
      corePricingConfig.joinTableData.splice(
         corePricingConfig.selectedRowDetails.currentRow + 1,
         0,
         tableObjects.fullCollection[0]
      );
   };
   const handleEditDataUpdated = (
      value,
      item,
      isSecondary,
      type,
      updatedRow
   ) => {
      if (type === CAMEL_CASE_ACTION.CHANGE) {
         if (!isSecondary) {
            corePricingConfig.primaryTable[item.rowIndex][item.dataKey] = value;
            if (item.dataKey === 'cxr')
               corePricingConfig.secondaryTable[item.rowIndex][item.dataKey] =
                  value;
         } else
            corePricingConfig.secondaryTable[item.rowIndex][item.dataKey] =
               value;
         setCorePricingConfig({
            ...corePricingConfig,
            insertIndex: item.rowIndex,
         });
      } else if (
         type === CAMEL_CASE_ACTION.BLUR ||
         type === CAMEL_CASE_TYPES.MULTIEDIT
      ) {
         const selectedRowDetails =
            type === CAMEL_CASE_TYPES.MULTIEDIT
               ? updatedRow
               : corePricingConfig.selectedRowDetails.selectedRowIndex;
         if (item.dataKey === 'fbc') {
            selectedRowDetails.forEach((rowIndex) => {
               if (
                  corePricingConfig.primaryTable[rowIndex].uac ===
                     USER_ACTION_CODE_FARES_SCREEN.UPDATE ||
                  corePricingConfig.primaryTable[rowIndex].uac ===
                     USER_ACTION_CODE_FARES_SCREEN.NEW ||
                  selectedRowDetails.length === 1
               ) {
                  let defaultValue = clone(value);
                  const underscoreCharacter = defaultValue
                     .split('')
                     .reduce((valueOne, valueTwo, index) => {
                        return valueOne.concat(valueTwo === '_' ? index : []);
                     }, []);
                  let updatedValue = defaultValue.split('');
                  underscoreCharacter.map((updateItem) => {
                     const index = defaultValue.toString().indexOf('_');
                     updatedValue[updateItem] =
                        corePricingConfig.joinTableData[rowIndex][item.dataKey][
                           updateItem
                        ];
                     updatedValue.join('');
                     defaultValue = updatedValue;
                  });
                  if (!isSecondary)
                     corePricingConfig.primaryTable[rowIndex][item.dataKey] =
                        Array.isArray(defaultValue)
                           ? defaultValue.join('')
                           : defaultValue;
                  else
                     corePricingConfig.secondaryTable[rowIndex][item.dataKey] =
                        Array.isArray(defaultValue)
                           ? defaultValue.join('')
                           : defaultValue;
                  corePricingConfig.secondaryTable[
                     rowIndex
                  ].isDoubleClick = false;
                  corePricingConfig.primaryTable[
                     rowIndex
                  ].isDoubleClick = false;
               }
               if (
                  type === CAMEL_CASE_TYPES.MULTIEDIT &&
                  item.rowData.isDoubleClick &&
                  selectedRowDetails.length > 1 &&
                  !item.rowData.uac
               ) {
                  const updatedData = handleTableRowUndo(
                     isSecondary
                        ? corePricingConfig.secondaryTable
                        : corePricingConfig.primaryTable,
                     item
                  );
                  isSecondary
                     ? corePricingConfig.secondaryTable.splice(
                          updatedData.index,
                          1,
                          updatedData.data
                       )
                     : corePricingConfig.primaryTable.splice(
                          updatedData.index,
                          1,
                          updatedData.data
                       );
               }
            });
            setCorePricingConfig({
               ...corePricingConfig,
               insertIndex: item.rowIndex,
            });
            !item.rowData.uac &&
               type !== CAMEL_CASE_TYPES.MULTIEDIT &&
               configureNewRow(value, item, isSecondary);
         } else if (isNaN(value)) {
            handleMathOperation(value, item, isSecondary, selectedRowDetails);
            if (
               type === CAMEL_CASE_TYPES.MULTIEDIT &&
               item.rowData.isDoubleClick &&
               selectedRowDetails.length > 1 &&
               !item.rowData.uac
            ) {
               const updatedData = handleTableRowUndo(
                  isSecondary
                     ? corePricingConfig.secondaryTable
                     : corePricingConfig.primaryTable,
                  item
               );
               isSecondary
                  ? corePricingConfig.secondaryTable.splice(
                       updatedData.index,
                       1,
                       updatedData.data
                    )
                  : corePricingConfig.primaryTable.splice(
                       updatedData.index,
                       1,
                       updatedData.data
                    );
            }
         }
      } else if (type === CAMEL_CASE_ACTION.UPDATES) {
         if (item.dataKey === 'amt' && isNaN(value)) {
            handleMathOperation(
               value,
               item,
               isSecondary,
               corePricingConfig.selectedRowDetails.selectedRowIndex
            );
            if (value[0] !== '=' || !MATH_OPERATIONS.includes(value[1])) return;
         }
         configureNewRow(value, item, isSecondary);
      }
   };
   const handleTableRowUndo = (tableData, item) => {
      const defaultValue = corePricingConfig.joinTableData.find(
         (list) => list.id === item.rowData.id
      )[item.dataKey];
      const tableRow = tableData.find((list) => list.id === item.rowData.id);
      const tableIndex = tableData.indexOf(
         (list) => list.id === item.rowData.id
      );
      tableRow[item.dataKey] = defaultValue;
      tableRow.isDoubleClick = false;
      return { data: tableData, index: tableIndex };
   };
   const isNewRecordIsAvailable = () => {
      return corePricingConfig.primaryTable.filter(
         (item) => item.uac === USER_ACTION_CODE_FARES_SCREEN.NEW
      ).length > 0
         ? true
         : false;
   };
   const callDistributionFetchApi = () => {
      setDistributionFetchApi({
         method: 'POST',
         url: URL_NEW_DISTRIBUTION_GROUP_SEARCH,
         data: [
            {
               key: 'dgNumber',
               operator: '==',
               value: corePricingConfig.distributionNumber,
            },
         ],
      });
   };
   useEffect(() => {
      if (
         !corePricingConfig.isDistributionNumberApiCall &&
         corePricingConfig.isSave &&
         corePricingConfig.distributionNumber &&
         isNewRecordIsAvailable
      ) {
         parsingSavedDataWithApiCall();
      }
   }, [corePricingConfig.isDistributionNumberApiCall]);

   useEffect(() => {
      if (distributionFetchApi.data && !distributionFetchApi.isLoading) {
         if (
            distributionFetchApi.data &&
            distributionFetchApi.data.length > 0
         ) {
            const isDistributed =
               distributionFetchApi.data[0].distributionGroupLogs.some(
                  (list) => list.action === 'DISTRIBUTED'
               );
            if (!isDistributed) parsingSavedDataWithApiCall();
            else toastWarn(NOTIFICATION_MESSAGES.ALREADY_DISTRIBUTED);
         } else if (
            distributionFetchApi.data &&
            distributionFetchApi.data.length === 0 &&
            corePricingConfig.isSave
         ) {
            toastWarn(NOTIFICATION_MESSAGES.DISTRIBUTION_GROUP_DOES_NOT_EXIST);
         }
      } else if (distributionFetchApi.error) {
         toastWarn(distributionFetchApi.error);
      }
   }, [distributionFetchApi.isLoading]);

   const newFaresEmptyValidationCheck = () => {
      const splitingObjects = calculateJoinData(
         corePricingConfig.primaryTable,
         corePricingConfig.secondaryTable
      );
      const result = generationgTableObjects(splitingObjects);
      if (result.fullCollection.length > 0) {
         let validationDetails = { isValidData: true, index: -1 };

         result.fullCollection.find((list, index) => {
            list.cxr = corePricingConfig.primaryTable[index].cxr;
            if (
               (!list.org ||
                  !list.des ||
                  !list.cxr ||
                  !list.fbc ||
                  !list.tar ||
                  !list.owrt ||
                  !list.cur ||
                  !list['eff dt']) &&
               list.uac
            ) {
               validationDetails.isValidData = false;
               validationDetails.index = index;
            }
         });
         return validationDetails;
      }
   };
   const getDistributionNumberDetails = () => {
      const isValidation = newFaresEmptyValidationCheck();
      if (!isValidation.isValidData && isValidation.index >= 0) {
         showWarning(
            `Row Number ${
               isValidation.index + 1
            } - Mandatory field is missing. Could you please fill and save`
         );
         return;
      }

      if (corePricingConfig.distributionNumber) {
         setCorePricingConfig({
            ...corePricingConfig,
            isDistributionNumberApiCall: false,
            isSave: true,
         });
         if (isNewRecordIsAvailable && !distributionFetchApi.isLoading) {
            callDistributionFetchApi();
         }
      } else {
         setCorePricingConfig({
            ...corePricingConfig,
            isDistributionNumberApiCall: true,
            isSave: true,
         });
      }
   };
   const parsingSavedDataWithApiCall = () => {
      corePricingConfig.primaryTable.forEach((record, index) => {
         if (
            (record.uac === USER_ACTION_CODE_FARES_SCREEN.NEW ||
               record.uac === USER_ACTION_CODE_FARES_SCREEN.UPDATE) &&
            record.isInsert
         ) {
            const item = {
               ...corePricingConfig.primaryTable[index],
               ...corePricingConfig.secondaryTable[index],
            };
            item.owrt = item.owrt === '3' ? '1' : item.owrt;
            corePricingConfig.primaryTable[index].fareKey = `${
               item.cxr ? item.cxr : null
            }-${item.org ? item.org : null}-${item.des ? item.des : null}-${
               item.fbc ? item.fbc : null
            }-${item.cur ? item.cur : null}-${item.owrt ? item.owrt : null}-${
               item.rtg ? item.rtg : item.rtg === 0 ? item.rtg : null
            }-${item.tar ? item.tar : null}-${item.ft ? item.ft : null}`;
            corePricingConfig.secondaryTable[index].fareKey = `${
               item.cxr ? item.cxr : null
            }-${item.org ? item.org : null}-${item.des ? item.des : null}-${
               item.fbc ? item.fbc : null
            }-${item.cur ? item.cur : null}-${item.owrt ? item.owrt : null}-${
               item.rtg ? item.rtg : item.rtg === 0 ? item.rtg : null
            }-${item.tar ? item.tar : null}-${item.ft ? item.ft : null}`;
            corePricingConfig.joinTableData[index].fareKey = `${
               item.cxr ? item.cxr : null
            }-${item.org ? item.org : null}-${item.des ? item.des : null}-${
               item.fbc ? item.fbc : null
            }-${item.cur ? item.cur : null}-${item.owrt ? item.owrt : null}-${
               item.rtg ? item.rtg : item.rtg === 0 ? item.rtg : null
            }-${item.tar ? item.tar : null}-${item.ft ? item.ft : null}`;
         }
      });
      const primary = corePricingConfig.primaryTable.filter(
         (item) =>
            (item.uac === USER_ACTION_CODE_FARES_SCREEN.NEW ||
               item.uac === USER_ACTION_CODE_FARES_SCREEN.UPDATE) &&
            item.isInsert
      );
      const secondary = corePricingConfig.secondaryTable.filter(
         (item) =>
            (item.uac === USER_ACTION_CODE_FARES_SCREEN.NEW ||
               item.uac === USER_ACTION_CODE_FARES_SCREEN.UPDATE) &&
            item.isInsert
      );
      const splitingObjects = calculateJoinData(primary, secondary);
      const result = generationgTableObjects(splitingObjects);
      const saveData = result.fullCollection.map((item) => {
         const newRowObject = {
            origin: item.org,
            destination: item.des,
            carrierCode: item.cxr,
            fareClassCode: item.fbc,
            tariffNumber: parseInt(item.tar),
            footnoteCode: item.ft,
            routingNumber: parseInt(item.rtg),
            roundTripIndicator:
               parseInt(item.owrt) === 3 ? 1 : parseInt(item.owrt),
            currencyCode: item.cur,
            fareAmount: parseInt(item.amt),
            effectiveDate: item['eff dt'],
            userActionCode: item.uac,
            dgNumber: corePricingConfig.distributionNumber,
            fareKey: item.fareKey,
            hostCarrier: item.cxr,
         };
         const NO_VALIDATION_FIELS = ['routingNumber', 'fareAmount'];
         for (const [key, value] of Object.entries(newRowObject)) {
            if (!value && !NO_VALIDATION_FIELS.includes(key))
               delete newRowObject[key];
         }
         return newRowObject;
      });

      if (!saveNewFares.isLoading)
         setSaveNewFares({
            method: 'POST',
            url: URL_CORE_PRICING_NEW_FARES_SAVE,
            data: saveData,
         });
   };
   const filteringSelectedFaresList = () => {
      const workingFares = corePricingConfig.joinTableData.filter(
         (record, index) =>
            record.status === FARE_STATUS.WORKING &&
            record.dg &&
            corePricingConfig.selectedRowDetails?.selectedRowIndex?.includes(
               index
            )
      );
      const workingFaresUpdatedData = workingFares.map((list) => {
         return {
            origin: list.org,
            destination: list.des,
            fareClassCode: list.fbc,
            carrierCode: list.cxr,
            tariffNumber: list.tar,
            footnoteCode: list.ft,
            routingNumber: list.rtg,
            roundTripIndicator: list.owrt,
            currencyCode: list.cur,
            fareAmount: list.amt,
            userActionCode: list.uac,
            dgNumber: list.dg,
         };
      });
      return {
         screen: SCREEN_NAMES.FARES,
         hostCarrier: fetchConfig.requestedData.hostCarrier,
         distributionGroupNumber: {
            carrierCode: sessionStorage.getItem('carrierCode'),
            user: app.User.firstName,
            workingFares: workingFaresUpdatedData,
         },
      };
   };
   const deleteFaresDetails = () => {
      handleDeleteDistributionMenuClick(filteringSelectedFaresList());
      setCorePricingConfig({
         ...corePricingConfig,
         selectedRowDetails: {
            currentRow: corePricingConfig.selectedRowDetails.currentRow,
            selectedCellIndex:
               corePricingConfig.selectedRowDetails.selectedCellIndex,
            selectedCellTableType:
               corePricingConfig.selectedRowDetails.selectedCellTableType,
            selectedRowIndex:
               corePricingConfig.selectedRowDetails.selectedRowIndex,
         },
      });
   };
   const saveFares = (type) => {
      if (type === CAMEL_CASE_TYPES.SAVE) getDistributionNumberDetails();
      else if (type === CAMEL_CASE_TYPES.DELETE) {
         if (
            corePricingConfig.joinTableData.filter(
               (list) => list.status === FARE_STATUS.WORKING && list.dg
            ).length > 0
         ) {
            deleteFaresDetails();
         }
      }
   };
   const removeCellData = (selectionDetails) => {
      if (selectionDetails.table === CAMEL_CASE_TYPES.PRIMARY_TABLE)
         corePricingConfig.primaryTable[selectionDetails.row][
            selectionDetails.key
         ] = '';
      else
         corePricingConfig.secondaryTable[selectionDetails.row][
            selectionDetails.key
         ] = '';

      setCorePricingConfig({
         ...corePricingConfig,
         insertIndex: selectionDetails.row,
      });
   };
   const getDistributionGroupNumber = (distributionNumber) => {
      setCorePricingConfig({
         ...corePricingConfig,
         distributionNumber: distributionNumber,
         isDistributionNumberApiCall: false,
      });
   };
   const tableComponent = () => {
      return (
         <div
            className={`${
               corePricingConfig.primaryTable.length === 0 && 'default-height'
            } ${
               corePricingConfig.joinTableData.length === 0 &&
               !corePricingConfig.isLeftSideLayoutOpen
                  ? 'center-loader'
                  : ''
            }`}
            tabIndex={0}
            onBlur={() => handleOutSideClick()}
         >
            {(!fetchConfig.isLoading ||
               fetchConfig.type === CAMEL_CASE_ACTION.PAGINATION_ACTION) &&
            !corePricingConfig.isFilterApply ? (
               corePricingConfig.primaryHeaderDetails.length > 0 ? (
                  <>
                     <div className='spark-flex'>
                        <TableView
                           rowData={corePricingConfig.primaryTable}
                           reference={primaryTableReference}
                           handleScrolling={(event) =>
                              handleScroll(
                                 event,
                                 CAMEL_CASE_TYPES.PRIMARY_TABLE
                              )
                           }
                           getSelectedIndex={getSelectedIndex}
                           selectedRowDetails={
                              corePricingConfig.selectedRowDetails
                           }
                           selectedCellIndexValue={
                              corePricingConfig.selectedCellIndex
                           }
                           headerData={corePricingConfig.primaryHeaderDetails}
                           handleSorting={handleSorting}
                           totalItem={
                              fetchConfig.pageToken
                                 ? fetchConfig.totalItem
                                 : corePricingConfig.joinTableData.length
                           }
                           isMultiFilter
                           isToolTipShow
                           title={[{ titleName: 'Identifier', width: 0 }]}
                           uniqueFilters={corePricingConfig.uniqueFilters}
                           handleScroll={handlePrimaryTableScroll}
                           handleFilterChange={handleFilterChange}
                           handleShowSearchFilters={
                              handleEnablesPrimaryHeadersControls
                           }
                           handleEnablesHeadersControls={
                              handleEnablesPrimaryHeadersControls
                           }
                           handleUniqueItemClick={handleUniqueItemClick}
                           handleSelectAllUpdate={handleSelectAllUpdate}
                           handleClearEvent={handleClearEvent}
                           handleKeyPressEvent={handleKeyPressEvent}
                           handleFilterUniqueItems={handleFilterUniqueItems}
                           handleRecordClick={handleRecordClick}
                           fullData={corePricingConfig.joinTableData}
                           isStopAPI={stopApiRequest}
                           hostCarrier={fetchConfig.requestedData.hostCarrier}
                           handleInsertRow={handleInsertRow}
                           isFetchDataCompleted={
                              typeof fetchConfig.pageToken === 'undefined' ||
                              !fetchConfig.pageToken
                                 ? true
                                 : false
                           }
                           handleEditDataUpdated={handleEditDataUpdated}
                           showWarning={showWarning}
                           copyRow={copyRow}
                           selectedScreen={selectedScreen}
                           removeCellData={removeCellData}
                           newTemplateIds={newTemplateId}
                           distributionListApproveAction={saveFares}
                           updateDoubleClicRows={updateDoubleClicRows}
                        />
                        <TableView
                           rowData={corePricingConfig.secondaryTable}
                           reference={secondaryTableReference}
                           handleScrolling={(event) =>
                              handleScroll(
                                 event,
                                 CAMEL_CASE_TYPES.SECONDARY_TABLE
                              )
                           }
                           isScroll
                           totalItem={
                              fetchConfig.pageToken
                                 ? fetchConfig.totalItem
                                 : corePricingConfig.joinTableData.length
                           }
                           isLeftSideLayoutOpen={
                              corePricingConfig.isLeftSideLayoutOpen
                           }
                           getSelectedIndex={getSelectedIndex}
                           selectedRowDetails={
                              corePricingConfig.selectedRowDetails
                           }
                           selectedCellIndexValue={
                              corePricingConfig.selectedCellIndex
                           }
                           headerData={corePricingConfig.secondaryHeaderDetails}
                           handleSorting={handleSorting}
                           isMultiFilter
                           isToolTipShow
                           title={[
                              { titleName: 'Fare Value', width: 0 },
                              { titleName: 'Rule', width: 0 },
                              { titleName: 'Footnote', width: 0 },
                              { titleName: 'Distribution', width: 0 },
                              { titleName: 'Fare Class', width: 0 },
                              { titleName: 'Brand', width: 0 },
                              { titleName: 'Market', width: 0 },
                           ]}
                           sepratorCaption={corePricingConfig.sepratorCaption}
                           uniqueFilters={corePricingConfig.uniqueFilters}
                           titleDetails={corePricingConfig.titleDetails}
                           handleScroll={handleSecondaryTableScroll}
                           handleFilterChange={handleFilterChange}
                           handleShowSearchFilters={
                              handleEnablesPrimaryHeadersControls
                           }
                           handleEnablesHeadersControls={
                              handleEnablesPrimaryHeadersControls
                           }
                           handleUniqueItemClick={handleUniqueItemClick}
                           handleSelectAllUpdate={handleSelectAllUpdate}
                           handleClearEvent={handleClearEvent}
                           handleKeyPressEvent={handleKeyPressEvent}
                           handleFilterUniqueItems={handleFilterUniqueItems}
                           handleRecordClick={handleRecordClick}
                           fullData={corePricingConfig.joinTableData}
                           isStopAPI={stopApiRequest}
                           hostCarrier={fetchConfig.requestedData.hostCarrier}
                           handleInsertRow={handleInsertRow}
                           isFetchDataCompleted={
                              typeof fetchConfig.pageToken === 'undefined' ||
                              !fetchConfig.pageToken
                                 ? true
                                 : false
                           }
                           handleEditDataUpdated={handleEditDataUpdated}
                           showWarning={showWarning}
                           copyRow={copyRow}
                           selectedScreen={selectedScreen}
                           removeCellData={removeCellData}
                           newTemplateIds={newTemplateId}
                           distributionListApproveAction={saveFares}
                           updateDoubleClicRows={updateDoubleClicRows}
                        />
                     </div>
                     <NewDistributionGroup
                        userName={app.userId}
                        email={app.User.email}
                        showWarning={showWarning}
                        isDistributionNumberApiCall={
                           corePricingConfig.isDistributionNumberApiCall
                        }
                        handleDistributionScreenNavigation={
                           handleDistributionScreenNavigation
                        }
                        selectedRowDetails={
                           corePricingConfig.selectedRowDetails
                        }
                        getDistributionGroupNumber={getDistributionGroupNumber}
                     />
                  </>
               ) : (
                  <div className='spark-flex spark-align-items-center no-record-text spark-bold'>
                     No fare result found.
                  </div>
               )
            ) : (
               (fetchConfig.isLoading || corePricingConfig.isFilterApply) && (
                  <Loader
                     className={` ${
                        corePricingConfig.isSaveSearchCriteria
                           ? 'loader-container-full'
                           : 'core-pricing-fares-loader'
                     }`}
                     size={SIZE.SMALL}
                  />
               )
            )}
         </div>
      );
   };

   const handleStatusLeftSideLayout = (isLeftSideLayoutOpen) => {
      setCorePricingConfig({
         ...corePricingConfig,
         isLeftSideLayoutOpen,
      });
   };

   const handleSearchCriteriaSearch = () => {
      setCorePricingConfig({
         ...corePricingConfig,
         isLeftSideLayoutOpen: !corePricingConfig.isLeftSideLayoutOpen,
      });
   };

   return (
      <div className='core-pricing-fares-root-view'>
         <div className='row core-pricing-fares-root-view-padding-left-right'>
            <LayoutTwoVerticalGrids
               isExpanded={corePricingConfig.isLeftSideLayoutOpen}
               leftComponent={searchCriteriaComponent()}
               rightComponent={tableComponent()}
               isCorePricing
               handleStatusLeftSideLayout={handleStatusLeftSideLayout}
            />
         </div>
      </div>
   );
};

CorePricingFares.propTypes = {
   app: object,
   loadTime: string,
   selectedScreen: string,
   getTableData: func,
   getSearchCriteriaParent: func,
   getFullDataIsAvailable: func,
   handleDistributionScreenNavigation: func,
   handleNewFaresErrorPopupOpen: func,
   handleDeleteDistributionMenuClick: func,
   deleteConformedDistributionList: array,
};

export default CorePricingFares;
